
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/right-to-left",
      function () {
        return require("private-next-pages/material-ui/customization/right-to-left.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/right-to-left"])
      });
    }
  